import { render } from "./DescriptionTypeList.vue?vue&type=template&id=a43b4f70&scoped=true"
import script from "./DescriptionTypeList.vue?vue&type=script&lang=js"
export * from "./DescriptionTypeList.vue?vue&type=script&lang=js"

import "./DescriptionTypeList.vue?vue&type=style&index=0&id=a43b4f70&scoped=true&lang=css"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a43b4f70"]])

export default __exports__